module.exports = {
  "course": {},
}



// WEBPACK FOOTER //
// ./src/i18n/course/en.js